import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2c56676c&scoped=true&"
import script from "./Detail.js?vue&type=script&lang=js&"
export * from "./Detail.js?vue&type=script&lang=js&"
import style0 from "./Detail.css?vue&type=style&index=0&id=2c56676c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56676c",
  null
  
)

export default component.exports